function toggleCartIcon() {
  const shoppingBag = document.querySelector('.cart-link__bubble');
  // console.log(shoppingBag);
}

export default toggleCartIcon;
